import styled from 'styled-components';

import ContentContainer from '../ContentContainer';

const enabled = process.env.NEXT_PUBLIC_EDITING_NOTICE_ENABLED === 'true';

const Wrapper = styled.div`
  font-size: 0.9em;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.1);

  a {
    text-decoration: underline;
  }

  padding: ${({ $padding = '10px' }) => $padding};
`;

const Label = styled.p`
  text-transform: uppercase;
  font-weight: 600;
`;

const Disclaimer = styled.p`
  font-size: 0.9em;
`;

export function EditingNote({ padding, children }) {
  if (!enabled) {
    return null;
  }
  return (
    <Wrapper $padding={padding}>
      <ContentContainer>
        <Label>Editing note</Label>
        {children}
        <Disclaimer>This note is private and not displayed to our users</Disclaimer>
      </ContentContainer>
    </Wrapper>
  );
}
